export default "__VITE_ASSET__Bklz5DZB__"